<template>
  <div class="Certificate">
    <div class="content">
      <div class="box">
        <table border="1" cellspacing="0" cellpadding="2" class="table-one">
          <tbody>
            <th colspan="9"><span class="line">|</span> 招生专业信息</th>
            <tr>
              <td class="required">姓名</td>
              <td colspan="2">
                <el-input :disabled="true" v-model="formData.xm" maxlength="50">
                </el-input>
              </td>
              <td class="required">性别</td>
              <td colspan="2">
                <el-input :disabled="true" v-model="formData.xbm"></el-input>
              </td>
              <td class="required">民族</td>
              <td colspan="2">
                <span style="margin-left: 10px; color: #606266">{{
                  formData.mzmc
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="required">年龄</td>
              <td colspan="2">
                <el-input :disabled="true" v-model="formData.age"> </el-input>
              </td>
              <td class="required">身份证号码</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.zjhm"
                  maxlength="20"
                >
                </el-input>
              </td>
              <td class="required">政治面貌</td>
              <td colspan="2">
                <span style="margin-left: 10px; color: #606266">{{
                  formData.zzmmc
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="required">学校名称</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.xxmc"
                  maxlength="50"
                >
                </el-input>
              </td>
              <td class="required">学历</td>
              <td colspan="2">
                <el-input :disabled="true" v-model="formData.xlm"></el-input>
              </td>
              <td class="required">院系</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.xymc"
                  maxlength="50"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="required">专业</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.zymc"
                  maxlength="50"
                >
                </el-input>
              </td>
              <td class="required">拟毕业时间</td>
              <td colspan="2">
                <div class="block">
                  <el-date-picker v-model="formData.bysj" disabled type="date">
                  </el-date-picker>
                </div>
              </td>
              <td class="required">本人银行卡号</td>
              <td colspan="2">
                <el-input
                  v-model="formData.yhkh"
                  placeholder="请输入(用于发放交通补贴,请准确填写)"
                  :disabled="true"
                ></el-input>
              </td>
              <!-- <td class="required">是否参评优秀营员特等奖</td>
              <td colspan="2">
                <el-radio disabled v-model="formData.sfzs" label="1"
                  >是</el-radio
                >
                <el-radio disabled v-model="formData.sfzs" label="0"
                  >否</el-radio
                >
              </td> -->
            </tr>
            <tr>
              <!-- <td class="required">是否参评优秀营员一等奖</td>
                            <td colspan="2">
                                <el-radio disabled v-model="formData.sfpj" label="1">是</el-radio>
                                <el-radio disabled v-model="formData.sfpj" label="0">否</el-radio>
                            </td> -->
              <td class="required">开户银行</td>
              <td colspan="2">
                <el-input
                  v-model="formData.khyh"
                  :disabled="true"
                  placeholder="请输入"
                  maxlength="30"
                ></el-input>
              </td>

              <td class="required">邮箱</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.email"
                  maxlength="50"
                >
                </el-input>
              </td>
              <td class="required">本人联系电话</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.yddh"
                  maxlength="20"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <!-- <td class="required">家长联系电话</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.lxdh"
                  maxlength="20"
                >
                </el-input>
              </td> -->
              <td class="required">紧急联系人电话</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.jjlxrdh"
                  maxlength="11"
                >
                </el-input>
              </td>
              <td class="required">家庭住址</td>
              <td colspan="4">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="formData.jtzz"
                  placement="top"
                >
                  <div class="tooltip-content">
                    <el-input
                      :disabled="true"
                      v-model="formData.jtzz"
                      maxlength="200"
                    ></el-input>
                  </div>
                </el-tooltip>
              </td>
            </tr>
            <tr>
              <td class="required">感兴趣的研究方向</td>
              <td colspan="8">
                <el-input
                  :disabled="true"
                  v-model="formData.yjfx"
                  resize="none"
                  type="textarea"
                  maxlength="300"
                  :autosize="{ minRows: 3, maxRows: 5 }"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="required">主要学习和工作经历（从高中开始写起）</td>
              <td colspan="8">
                <el-input
                  :disabled="true"
                  v-model="formData.xxgzjl"
                  resize="none"
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 10 }"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td>科研经历</td>
              <td colspan="8">
                <el-input
                  :disabled="true"
                  v-model="formData.kyjl"
                  resize="none"
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 10 }"
                >
                </el-input>
              </td>
            </tr>
          </tbody>
        </table>
        <table border="1" cellspacing="0" cellpadding="2" class="table-one">
          <tbody>
            <th colspan="9"><span class="line">|</span> 成绩信息</th>
            <tr>
              <td class="required">截止目前综合成绩排名</td>
              <td colspan="2">
                <el-input :disabled="true" v-model="formData.rank"></el-input>
              </td>
              <td>四级</td>
              <td colspan="2">
                <el-radio
                  disabled
                  v-model="formData.level4"
                  :label="true"
                  style="margin-left: 10px"
                  >是</el-radio
                >
                <el-radio disabled v-model="formData.level4" :label="false"
                  >否</el-radio
                >
              </td>
              <td>四级成绩</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.level4Grades"
                  v-if="formData.level4 == '1'"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td>六级</td>
              <td colspan="2">
                <el-radio
                  disabled
                  v-model="formData.level6"
                  :label="true"
                  style="margin-left: 10px"
                  >是</el-radio
                >
                <el-radio disabled v-model="formData.level6" :label="false"
                  >否</el-radio
                >
              </td>
              <td>六级成绩</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.level6Grades"
                  v-if="formData.level6 == '1'"
                >
                </el-input>
              </td>
              <td>雅思成绩</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.ieltsScore"
                ></el-input>
              </td>
            </tr>
            <tr>
              <td>托福成绩</td>
              <td colspan="2">
                <el-input :disabled="true" v-model="formData.toeflScores">
                </el-input>
              </td>
              <td>GRE成绩</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.greScore"
                ></el-input>
              </td>
              <td>GMAT成绩</td>
              <td colspan="2">
                <el-input
                  :disabled="true"
                  v-model="formData.gmatScore"
                ></el-input>
              </td>
            </tr>
          </tbody>
        </table>
        <table border="1" cellspacing="0" cellpadding="2" class="table-one">
          <tbody>
            <th colspan="9">
              <span class="line">|</span> <span style="color: #333">获奖</span>
            </th>
            <tr>
              <td colspan="9" style="background: #fff">
                <el-input
                  v-model="formData.hjxx"
                  resize="none"
                  maxlength="3000"
                  :disabled="true"
                  type="textarea"
                  :autosize="{ minRows: 8, maxRows: 15 }"
                >
                </el-input>
              </td>
            </tr>
          </tbody>
        </table>
        <table border="1" cellspacing="0" cellpadding="2" class="table-one">
          <tbody>
            <th colspan="9">
              <span class="line">|</span> <span style="color: #333">课题</span>
            </th>
            <tr>
              <td colspan="9" style="background: #fff">
                <el-input
                  v-model="formData.kt"
                  resize="none"
                  maxlength="3000"
                  :disabled="true"
                  type="textarea"
                  :autosize="{ minRows: 8, maxRows: 15 }"
                >
                </el-input>
              </td>
            </tr>
          </tbody>
        </table>
        <table border="1" cellspacing="0" cellpadding="2" class="table-one">
          <tbody>
            <th colspan="9">
              <span class="line">|</span>
              <span style="color: #333">学术论文</span>
            </th>
            <tr>
              <td colspan="9" style="background: #fff">
                <el-input
                  v-model="formData.xslw"
                  resize="none"
                  maxlength="3000"
                  :disabled="true"
                  type="textarea"
                  :autosize="{ minRows: 8, maxRows: 15 }"
                >
                </el-input>
              </td>
            </tr>
          </tbody>
        </table>
        <table border="1" cellspacing="0" cellpadding="2" class="table-one">
          <tbody>
            <th colspan="9">
              <span class="line">|</span>
              <span style="color: #333">出版物或其他原创性成果等信息</span>
            </th>
            <tr>
              <td colspan="9" style="background: #fff">
                <el-input
                  v-model="formData.yccg"
                  resize="none"
                  maxlength="3000"
                  :disabled="true"
                  type="textarea"
                  :autosize="{ minRows: 8, maxRows: 15 }"
                >
                </el-input>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <table border="1" cellspacing="0" cellpadding="2" class="table-one">
                    <tbody>
                        <th colspan="9"><i class="required">获奖、课题、学术论文、出版物或其他原创性成果等信息</i></th>
                        <tr>
                            <td colspan="9" style="background:#fff">
                                <el-input :disabled="true" placeholder="请输入获奖信息（包括获奖时间、获奖等级、获奖名称）"
                                    v-model="formData.hjxx" resize="none" type="textarea"
                                    :autosize="{ minRows: 8, maxRows: 15 }">
                                </el-input>
                            </td>
                        </tr>
                    </tbody>
                </table> -->
        <table border="1" cellspacing="0" cellpadding="2" class="table-one">
          <tbody>
            <th colspan="10"><span class="line">|</span> 其他信息</th>
            <tr>
              <td colspan="2">专业人数</td>
              <td colspan="8">
                <el-input :disabled="true" v-model="formData.zyrs"></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="2">其他对申请具有参考价值的情况</td>
              <td colspan="8">
                <el-input
                  :disabled="true"
                  v-model="formData.qtqk"
                  resize="none"
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 10 }"
                >
                </el-input>
              </td>
            </tr>
          </tbody>
        </table>
        <table border="1" cellspacing="0" cellpadding="2" class="table-one">
          <tbody>
            <th colspan="10"><span class="line">|</span> 证明材料</th>
            <tr>
              <td style="height: 10vh; background: #fff" v-if="formData.url">
                <a :href="formData.url" target="_blank">{{
                  formData.fileName
                }}</a>
                <!-- <iframe :src="formData.url" frameborder="0" width="100%" height="100%"></iframe> -->
              </td>
              <td style="background: #fff" v-else>
                <el-input
                  v-model="formData.xslw"
                  resize="none"
                  maxlength="3000"
                  :disabled="true"
                  type="textarea"
                  :autosize="{ minRows: 5 }"
                >
                </el-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: [],
      mzOptions: [],
      zzmmOptions: [],
      zjhm: "",
    };
  },
  methods: {
    goBack() {
      this.$emit("goBack", false);
    },
    loadDetail() {
      this.$http
        .get(`/camp/queryInfo/${this.zjhm}`)
        .then((res) => {
          let data = res.data.data;
          this.formData = data;
          console.log(data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // loadOption() {
    //     this.$http
    //         .get(`/api/system/dict/select/all`)
    //         .then(res => {
    //             console.log(54, res);
    //             this.mzOptions = res.data.data.mz
    //             this.zzmmOptions = res.data.data.zzmm
    //         })
    //         .catch(err => {
    //             console.log(err.message);
    //         });
    // },
  },
  created() {
    this.zjhm = this.$store.state.userData.userName;
    console.log(111, this.$store.state.userData.userName);
    this.loadDetail();
    // this.loadOption()
  },
};
</script>

<style scoped lang="scss">
.Certificate {
  width: 100%;
  background: #f2f2f2;
  font-size: 14px;
}

.line {
  color: #333 !important;
}

/deep/ .el-input__inner,
/deep/ .el-textarea__inner {
  border: none;
  background-color: #fff !important;
  color: #606266 !important;
}

/deep/ .el-radio__label {
  color: #606266 !important;
}

.summerCamp {
  width: 100%;
  height: 100vh;
  background: #f2f2f2;
}

.content {
  width: 1580px;
  padding: 30px 20px;
  // overflow-y: scroll;
  // overflow-x: hidden;
  background: #fff;
  font-size: 14px;
  margin: 20px auto;
}

.succ {
  width: 1500px;
  height: 100vh;
  background: #fff;
  text-align: center;
  margin: auto;

  img {
    width: 700px;
  }

  p {
    font-size: 30px;
  }
}
/deep/ .el-input__inner {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.title {
  width: 100%;
  height: 72px;
  background: linear-gradient(
    90deg,
    rgba(24, 144, 255, 1) 0%,
    rgba(24, 144, 255, 1) 0%,
    rgba(136, 199, 255, 1) 100%,
    rgba(136, 199, 255, 1) 100%
  );

  p {
    text-align: center;
    font-size: 28px;
    color: #fff;
    line-height: 72px;
    font-weight: 700;
  }
}

.success {
  width: 100%;
  text-align: center;

  p {
    font-size: 25px;
    font-weight: 600;
    color: #6ed284;
  }
}

.required:before {
  content: "*";
  color: red;
  margin-right: 5px;
}

.box {
  width: 1500px;
  margin: auto;

  .table-one {
    margin-bottom: 20px;

    td {
      &:nth-child(odd) {
        background: #f2f2f2;
        padding-left: 10px;
        text-align: left;
      }

      &:nth-child(even) {
        text-align: left;
        background: #fff;
      }

      .el-checkbox-group {
        padding-left: 20px;
      }
    }
  }

  table {
    width: 100%;
    border: 1px solid rgba(228, 228, 228, 1);
    border-collapse: collapse;
    color: #333;

    tbody > th {
      text-align: left;
      font-weight: 700;
      padding: 11px 2px 11px 10px;
      background: #e4e4e4;

      span {
        color: #1890ff;
      }
    }

    td {
      width: 200px;
      height: 40px;
      border: 1px solid #e5e5e5;
    }
  }
}.tooltip-content {
  // max-width: 200px; /* 设置最大宽度 */
  /* 或者直接设置固定宽度 */
  /* width: 200px; */
}

</style><style lang="css"> .el-tooltip__popper{ max-width:50% } </style>
